import React, {useRef, useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { Endpoints } from '../../Global/Endpoints';
import { t } from 'i18next';
import { useSelector } from 'react-redux';

const FeedServices = () => {
  const location = useLocation();
  const { link, description, videolink,documentlink } = location.state || {};
console.log('from countinue reading', { link, description, videolink ,documentlink});

  const [documents, setDocuments] = useState([]); // New state for documents
  const [articles, setArticles] = useState([]);
  const [videos, setVideos] = useState([]);
  const [loading, setLoading] = useState(true); // New loading state
  const token = localStorage.getItem('AccessToken');
  const navigate = useNavigate();
  const email = useSelector((state) => state.email.email);
  const deviceType = "PatientPortal";
  const userInfo = useSelector((state) => state.userData.userData);

  const ssoData = useSelector((state) => state.sso.ssoUserData);
  const isHighmarkPortal = ssoData?.Portal === "Highmark";
  console.log("window.location.pathname", window.location.pathname)

  useEffect(() => {
    
  if (window.location.pathname === '/feedServices' && !link && articles.length !=0) {
    console.log('State lost, reloading the page to restore state.');
    // If no link (state lost), force reload to re-fetch data
    window.location.reload();
  }
}, [window.location.pathname, link]);

// //   // Add this useEffect to handle Safari bfcache restore
//   useEffect(() => {
//   const handlePageShow = (event) => {
//     console.log('[FeedServices] pageshow event:', event);
//     if (event.persisted) {
//       console.log('[FeedServices] Page restored from bfcache, reloading...');
//       window.location.reload();
//     }
//   };
//   window.addEventListener('pageshow', handlePageShow);
//   return () => window.removeEventListener('pageshow', handlePageShow);
// }, []);

// useEffect(() => {
//   const handleVisibilityChange = () => {
//     console.log('[FeedServices] visibilitychange:', document.visibilityState);
//     if (document.visibilityState === 'visible') {
//       console.log('[FeedServices] Page became visible, setting loading to true');
//       setLoading(true);
//     }
//   };
//   document.addEventListener('visibilitychange', handleVisibilityChange);
//   return () => document.removeEventListener('visibilitychange', handleVisibilityChange);
// }, []);
  useEffect(() => {
    console.log('[FeedServices] fetchContent useEffect triggered', { link, token, loading });
    const fetchContent = async () => {
      console.log("Fetching content from + token:", link , token);
      setLoading(true); // Set loading to true when starting to fetch content
      if (link && token) {
        try {
          const params = {
            URL: link,
            EmailID:email,
            DeviceType:deviceType
          };
          const response = await axios.post(
            Endpoints.Getjson,
            `_Params=${encodeURIComponent(JSON.stringify(params))}`,
            {
              headers: {
                "Content-Type": "application/x-www-form-urlencoded",
                Authorization: `Bearer ${token}`,
              },
            }
          );
  
          const responseData = response.data;
  
          // Filter out items with empty fields
          if (responseData?.rss?.channel?.item) {
            setArticles(
              responseData.rss.channel.item.filter(
                item => item.name && item.link && item.image // Adjust fields as needed
              )
            );
          } else {
            console.error("Unexpected response structure:", responseData);
          }
        } catch (error) {
          console.error("Error fetching content:", error);
        } finally {
          setLoading(false); // Set loading to false after content is fetched
        }
      } else {
        setLoading(false); // Set loading to false if no link or token
      }
    };
  
    fetchContent();
  }, [link, token]);

  useEffect(() => {
    const fetchVideos = async () => {
      if (videolink) {
        try {
          const params = { URL: videolink, EmailID: email, DeviceType: deviceType };
          const response = await axios.post(
            Endpoints.Getjson,
            `_Params=${encodeURIComponent(JSON.stringify(params))}`,
            {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            }
          );

          const responseData = response.data;
          if (responseData?.rss?.channel?.item) {
            setVideos(
              responseData.rss.channel.item.filter(
                (video) =>
                  video.image &&
                  video.link &&
                  video.name &&
                  video.embed?.['#cdata-section'] &&
                  video.runtime
              )
            );
          }
        } catch (error) {
          console.error("Error fetching videos:", error);
        }
      }
    };

    fetchVideos();
  }, [videolink]);

  const handlePlayVideo = (video) => {
    const filteredVideos = videos.filter((v) => v !== video); // Exclude the current video
    navigate('/play-video', { state: { video, relatedVideos: filteredVideos,runtime:video.runtime } });
  };

  const handleContinueReading = (articleLink) => {
    const deviceType = "PatientPortal";
   const servicemodule="Education";
    const formattedActivity = `${servicemodule}:${description}:${articleLink}`;
  //  console.log(formattedActivity)
    if (userInfo.EmailID && token) {
      try {
        const payload = `_Params=${encodeURIComponent(
          JSON.stringify({ EmailID: userInfo.EmailID, Activity: formattedActivity, DeviceType: deviceType })
        )}`;
        axios.post(Endpoints.CallRecoderLog, payload, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: `Bearer ${token}`,
          },
        });

        // console.log(formattedActivity +"activity logged successfully.");
      } catch (error) {
      }
    }
    
    // Navigate to the ContinueReading component with the article link
    navigate('/continuereading', { state: { articlelink: articleLink, link, description, videolink,documentlink } });
  };

  const videoContainerRef = useRef(null);
  const [visibleCount, setVisibleCount] = useState(0);

  useEffect(() => {
    const calculateVisibleCount = () => {
      if (videoContainerRef.current) {
        const containerWidth = videoContainerRef.current.offsetWidth;
        const videoItemWidth = 200; 
        const count = Math.floor(containerWidth / videoItemWidth);
        setVisibleCount(count);
      }
    };

    calculateVisibleCount();
    window.addEventListener('resize', calculateVisibleCount);

    return () => {
      window.removeEventListener('resize', calculateVisibleCount);
    };
  }, []);


  useEffect(() => {
    const fetchDocuments = async () => {
      if (documentlink) {
        try {
          const params = { URL: documentlink, EmailID: email, DeviceType: deviceType };
          const response = await axios.post(
            Endpoints.Getjson,
            `_Params=${encodeURIComponent(JSON.stringify(params))}`,
            {
              headers: { "Content-Type": "application/x-www-form-urlencoded" },
            }
          );

          const responseData = response.data;
        
          if (responseData?.rss?.channel?.item) {
            setDocuments(
              responseData.rss.channel.item.filter(
                (doc) =>  doc.link && // Ensure document has a file link
                doc.name && // Ensure document has a name
                doc.image // Ensure document has a thumbnail image
              )
            );
          }
        } catch (error) {
          console.error("Error fetching documents:", error);
        }
      }
    };

    fetchDocuments();
  }, [documentlink]);
  const handleBackClick = () => {
    navigate(-1); // Redirects to the home page
  };
  const handleViewMoreVideos = () => {
    navigate('/view-more-videos', { state: { videos } });
  };
  const handleOpenDocument = (documentLink) => {
    window.open(documentLink, '_blank');
  };
  console.log(videos)

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading"></div>
        <h2 className="loading-text">{t("loading")}</h2>
      </div>
    );
  }

  return (
    <>

{isHighmarkPortal ? 
          <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>
              </span>
          </button>       
          <h2 className="page-heading">{t('himarkresourcestitle')}</h2>
          </div>:
          <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
          <button className="win-back-btn" onClick={handleBackClick}>
              <span>
              <i className="bi bi-chevron-left"></i>    
              {t('Back')}        
              </span>
          </button>       
          <h2 className="page-heading">{t('winresourcestitle')}</h2>
          </div>
      }
        
      {/* <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
        <button className="win-back-btn" onClick={handleBackClick}><span><i class='bi bi-chevron-left'></i> {t('back')}</span></button>
        <h2 className="page-heading">{t("winresourcestitle")}</h2>
      </div> */}
      
      <h4 className="page-heading-20-black-600 mb-4">{t('dynamicContent', { description })}</h4>
      {/* <div className="feed-services-list"> */}
      {videos.length > 0 && (
  <>
      <div className="all-videos-list" ref={videoContainerRef}>
        {videos.map((video, index) => (
          <div
            key={index}
            className="all-videos-list-item-wrapper"            
            onClick={() => handlePlayVideo(video)}
          >
            <div className="all-videos-list-item-thumb-wrapper">
              <img
                src={video.image}
                alt={video.name}
                className="all-videos-list-item-thumbnail"
              />

              <div className="play-button">
                <i className="bi bi-play-fill"></i>
              </div>
            </div>
            <div className="all-videos-list-video-info-wrapper">
              <h4 className="all-videos-list-video-title">{video.name}</h4>
              <span className="video-play-time">{video.runtime}</span>
            </div>
          </div>

        ))}
        
        {videos.length > visibleCount&& (
        <div className="all-videos-list-item-wrapper view-more-videos-wrapper">
          <button className="view-more" onClick={handleViewMoreVideos} >
            View More Videos
          </button>
        </div>
      )}
      </div>
      {videos.length >=1 && ( <div id="video-player-container" style={{ marginTop: '40px',marginBottom:'30px', border: '1px solid #ddd', borderRadius: '8px' }}></div>)}
</>
)}
      {documents.length > 0 && (
        <>
          <h4 className="page-heading-20-black-600 mt-2">{description + ' Toolkit'}</h4>          
            <div className="documents-list mt-2">
              {documents.map((document, index) => (
                <div
                  key={index}
                  className="document-item"
                  onClick={() => handleOpenDocument(document.file)}
                >
                  <div className="document-titles-wrapper">
                    <strong>{document.name}</strong>
                    <p>Forms and Policy Documents</p>
                  </div>
                  <div className="document-type-icon-wrapper document-type-pdf"></div>
                </div>
              ))}
            </div>
      <div id="video-player-container" style={{ marginTop: '20px', border: '1px solid #ddd', borderRadius: '8px' }}></div>

        </>
      )}
    
      <div class="container feed-services-list">
        
          {articles.length > 0 ? (
            <>
              {articles.map((item, index) => (
                <div key={index} className="feed-services-body">                  
                  <div class="card border-0">
                    <div className="card-image-wrapper">
                      {item.image && (
                        <img
                          src={item.image}
                          alt={item.name || "Image"}
                          className="img-fluid card-img-top"
                        />
                      )}
                    </div>
                    <div class="feed-services-title-wrapper">                      
                      <h2 className="feed-services-title m-0">{item.name}</h2>
                      {item.link && (
                          <button
                            onClick={() => handleContinueReading(item.link)}
                            className="feed-services-link highmark-option-no-border"
                          >
                           {t("continuereading")}
                          </button>                    
                      )}
                    </div>
                  </div>
                  
                </div>
              ))}
            </>
          ) : (
            <p>No content to display.</p>
          )}
        
      </div>
      <div id="video-player-container" className="mt-4" style={{border: '1px solid #ddd'}}></div>
     

    </>
  );
};

export default FeedServices;